var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/model/groupModel.ts";
import "core-js/modules/es.array.find.js";
import { createEvent, createStore } from 'effector';
import { isGroupType } from "../../../classifier-service/adapters";
export var setCurrentGroup = createEvent('setCurrentGroup', {
  name: "setCurrentGroup",
  sid: "kclley"
});
export var currentGroup$ = createStore(null, {
  name: "currentGroup$",
  sid: "-ptddix"
}).on(setCurrentGroup, function (_, item) {
  return item;
});
export function subscribeSelectNewGroup(_ref) {
  var flatTree$ = _ref.flatTree$,
      onCreatedNode = _ref.onCreatedNode;
  onCreatedNode.watch(function (result) {
    var newGroup = flatTree$.getState().find(function (_ref2) {
      var ref = _ref2.ref;
      return ref.type !== 'LoadMore' && ref.type !== 'CreateNode' && isGroupType(ref.type) && ref.id === result.id;
    });

    if (!(newGroup !== null && newGroup !== void 0 && newGroup.path) || newGroup.path.length > 1) {
      return;
    }

    setCurrentGroup({
      path: newGroup.path
    });
  });
}